import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { LogoutAction } from 'src/app/auth/store/auth.actions';
import { State } from '../../../store';

@Component({
    selector: 'app-logout',
    template: '',
})
export class LogoutComponent implements OnInit {
    constructor(private store: Store<State>) {}

    ngOnInit(): void {
        this.store.dispatch(LogoutAction());
        // Navigation is handled by AuthEffects.logout$ after oidcService.logoff() completes
    }
}
